import * as R from 'ramda'
import moment from 'moment-timezone'
import config from 'config'
import Cookie from 'js-cookie'

const invalidTimezones = [
  'ACT',
  'AET',
  'AGT',
  'ART',
  'AST',
  'BET',
  'BST',
  'CAT',
  'CNT',
  'CST',
  'CTT',
  'EAT',
  'ECT',
  'EST',
  'HST',
  'IET',
  'IST',
  'JST',
  'MIT',
  'MST',
  'NET',
  'NST',
  'PLT',
  'PNT',
  'PRT',
  'PST',
  'SST',
  'VST'
]

export const allTimezones = R.difference(moment.tz.names(), invalidTimezones)

export const COOKIE_KEY = config.NEXT_PUBLIC_COOKIE_NAME
export const CSRF_COOKIE_KEY = `${config.NEXT_PUBLIC_COOKIE_NAME}_CSRF`

export const cookieOpts = {
  domain: config.NEXT_PUBLIC_COOKIE_DOMAIN,
  expires: 14,
  path: '/',
  ...(config.NEXT_PUBLIC_SECURE_COOKIE
    ? {
        secure: true,
        sameSite: 'none',
        partitioned: config.NEXT_PUBLIC_PARTITION_COOKIE !== 'false'
      }
    : {})
}

export const setSessionCookies = (sessionId, csrfToken) => {
  Cookie.set(COOKIE_KEY, sessionId, cookieOpts)
  Cookie.set(CSRF_COOKIE_KEY, csrfToken, cookieOpts)
}

export const removeSessionCookies = () => {
  Cookie.remove(COOKIE_KEY, cookieOpts)
  Cookie.remove(CSRF_COOKIE_KEY, cookieOpts)
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4()
}

// TODO: should this go with the other graph fragments?
export const groupsQuery = board => [
  {
    '@loggedInUser': {
      keys: [
        {
          '@user/all-boards': {
            eids: [board[':db/id']],
            keys: [
              {
                ':board/groups': [
                  ':db/id',
                  ':group/name',
                  {
                    ':group/members': [
                      ':db/id',
                      ':user/squuid',
                      ':user/username',
                      ':user/firstname',
                      ':user/lastname',
                      ':user/avatar'
                    ]
                  }
                ]
              }
            ]
          }
        }
      ]
    }
  }
]
